import { render, staticRenderFns } from "./Modifiers.vue?vue&type=template&id=0ba80225&scoped=true"
import script from "./Modifiers.vue?vue&type=script&lang=js"
export * from "./Modifiers.vue?vue&type=script&lang=js"
import style0 from "./Modifiers.vue?vue&type=style&index=0&id=0ba80225&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba80225",
  null
  
)

export default component.exports